import { useTranslation } from "react-i18next";
import FormBlock from "../../Components/Inputs/FormBlock";
import { useState } from "react";
import { Spinner } from "../../Components/LoadingAnimations/LoadingAnimations";
import instance from "../../Interceptor/api_instance";
import { ActionResponse } from "../../Components/Modals/ActionResponses";

const YARDS = [
  {
    id: 1,
    name: "San Diego",
  },
  {
    id: 2,
    name: "Tijuana",
  },
];
const TransferStock = ({ row, location, close }) => {
  const toInventory = YARDS.find((a) => a.name !== location);
  const { t } = useTranslation();
  const [quantity, setQuantity] = useState(0);
  const [loading, setLoading] = useState(false);
  const [responseModal, setResponseModal] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const data = {
        stock_id: row.id,
        to_location_id: toInventory.id,
        quantity: parseInt(quantity),
      };
      const response = await instance.post("safety/transfer-parts", data);
      if (response.status === 200) {
        setResponseModal({
          message: t("forms.responses.success"),
          status: t("forms.type.success"),
        });
      }
    } catch (err) {
      console.log(err);
      setResponseModal({
        status: "Error",
        message: err,
      });
    } finally {
      setLoading(false);
    }

    console.log(loading);
  };
  return (
    <>
      {responseModal ? (
        <ActionResponse
          message={responseModal.message}
          status={responseModal.status}
          close={close}
        />
      ) : (
        <div className="page-mask page-mask-animation">
          <div className="white-cont">
            <h2 className="global-h2">
              {t("forms.type.maintenance-report.part.transfer.label")}
            </h2>
            <div>
              {t("yard-tables.table-columns.code")}: {row.part.sku}
            </div>
            <div>
              {t("yard-tables.table-columns.name")}: {row.part.name}
            </div>
            <div className="margin-bottom-24">
              {t("forms.type.maintenance-report.part.transfer.inStock")}:{" "}
              {row.quantity}
            </div>
            <div className="flex-1 margin-bottom-24">
              <label>
                {t("forms.type.maintenance-report.part.transfer.from")}:{" "}
                {location}
              </label>
              <label>
                {t("forms.type.maintenance-report.part.transfer.to")}:{" "}
                {toInventory.name}
              </label>
            </div>
            <form onSubmit={handleSubmit}>
              <div className="form-block">
                <label className="input-label required">
                  {t("general.yard")}
                </label>
                <div className="input-cont">
                  <select className="input-cont">
                    <option value={toInventory.id}>{toInventory.name}</option>
                  </select>
                </div>
              </div>
              <FormBlock
                label={t("forms.type.maintenance-report.labels.quantity")}
                name="quantity"
                value={quantity}
                isRequired={true}
                type={"number"}
                update={(e) => setQuantity(e.target.value)}
                max={row.quantity}
              />
              {loading ? (
                <Spinner />
              ) : (
                <div className="full-cont">
                  <button type="submit" className="change-pwd-btn">
                    {t("buttons.submit")}
                  </button>
                  <button className="cancel-btn" type="button" onClick={close}>
                    {t("buttons.cancel")}
                  </button>
                </div>
              )}
            </form>
          </div>
        </div>
      )}
    </>
  );
};

export default TransferStock;
